import 'animate.css/animate.min.css';
import Swal from 'sweetalert2'
import $clamp from 'clamp-js';
import { setupRellax } from "./common";
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const firePopup = (targetElement) => {
    const nodes = [];

    Swal.fire({
        position: 'center',
        html: '',
        showConfirmButton: false,
        showCloseButton: true,
        animation: false,
        customClass: {
            popup: 'animated zoomIn'
        },
        onOpen: (modalElement) => {
            while (targetElement.hasChildNodes()) {
                nodes.push(targetElement.firstChild);
                modalElement.appendChild(targetElement.firstChild);
            }
        },
        onClose: (modalElement) => {
            nodes.forEach((node) => {
                targetElement.appendChild(node);
            });
        },
    });
};

const setupPopups = () => {
    document.querySelectorAll('a[data-trigger-popup]').forEach((element) => {
        element.addEventListener('click', (e) => {
            const targetElement = document.querySelector(`.popup-content.${element.dataset["triggerPopup"]}`);
            firePopup(targetElement);
            e.preventDefault();
        });
    });
};

const setupSlides = () => {
    document.querySelectorAll('a[data-trigger-slide]').forEach((element) => {
        element.addEventListener('click', (e) => {
            const triggerSlide = element.dataset["triggerSlide"];
            const sliderElement= document.querySelector(`.slider-content.${triggerSlide}`);

            history.pushState({}, document.title, `${window.location.href.split('#')[0]}#${triggerSlide}`);

            sliderElement.classList.add('open');
            sliderElement.closest(".uagb-section__inner-wrap").classList.add('has-open');

            sliderElement.closest("div").closest("section").previousElementSibling.scrollIntoView();

            e.preventDefault();
        });
    });

    document.querySelectorAll('a[data-close-slide]').forEach((element) => {
        element.addEventListener('click', (e) => {
            const sliderElement = element.closest('.slider-content');

            sliderElement.classList.remove('open');
            sliderElement.closest(".uagb-section__inner-wrap").classList.remove('has-open');
            document.getElementById('capabilities').scrollIntoView();

            e.preventDefault();

            history.back();
        });
    });

    window.addEventListener('hashchange', (e) => {
        if (location.hash) {
            const target = document.querySelector(`.slider-content.${location.hash.substring(1)}`);

            if (target) {
                document.querySelectorAll('.slider-content')
                    .forEach(element => {
                        element.classList.remove('open');
                    });

                target.classList.add('open');
            }
        }

        const dropdown = document.getElementById("navigation-menu");

        if (dropdown && dropdown.classList.contains('visible')) {
            dropdown.classList.remove('visible');
        }
    }, false);

    const isInViewport = (el, percentVisible=1) => {
        let
            rect = el.getBoundingClientRect(percentVisible),
            windowHeight = (window.innerHeight || document.documentElement.clientHeight);

        return !(
            Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100)) < percentVisible ||
            Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
        )
    };

    const raf =
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function( callback ) {
            window.setTimeout( callback, 1000 / 60 )
        };

    let scrollStopped;

    const handler = () => raf( () => {
        window.clearTimeout(scrollStopped);

        scrollStopped = setTimeout(() => {

            const openSlider = document.querySelector('.slider-content.open');

            if (openSlider && !isInViewport(openSlider)) {
                openSlider.classList.remove('open');
                openSlider.closest(".uagb-section__inner-wrap").classList.remove('has-open');

                history.replaceState({}, document.title, `${window.location.href.split('#')[0]}#`);
            }

        }, 66);
    });

    window.addEventListener( 'scroll', handler );
};

const setupFlips = () => {
    document.querySelectorAll('.flip-container').forEach((targetFlipContainer) => {
        jQuery(targetFlipContainer).flip({
            trigger: 'manual',
            front: '.flip-front',
            back: '.flip-back',
        });

        targetFlipContainer.querySelector('.flip-back').addEventListener('click', (e) => {
            jQuery(targetFlipContainer).flip(false, () => {
                targetFlipContainer.classList.remove('flipped');
            });

            e.preventDefault();
        });

        targetFlipContainer.querySelector('a[data-trigger-flip]').addEventListener('click', (e) => {
            // reset all flips except current
            document.querySelectorAll('.flip-container.flipped').forEach(flipContainer => {
                jQuery(flipContainer).flip(false, () => {
                    flipContainer.classList.remove('flipped');
                });
            });

            jQuery(targetFlipContainer).flip(true);
            targetFlipContainer.classList.add('flipped');

            e.preventDefault();
        });
    });
};


const setupCarousel = () => {
    const slickSlider = document.querySelector('.image-carousel > div');

    if (slickSlider) {
        const observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting === true) {
                slickSlider.slick.slickGoTo(0);
                slickSlider.slick.slickPlay();
            } else {
                slickSlider.slick.slickGoTo(0);
                slickSlider.slick.slickPause();
            }
        }, { threshold: [0] });

        observer.observe(slickSlider);
    }
};

const handleOverflowingParagraphs = () => {
    const paragraphs = document.querySelectorAll(
        ".section-strategies .wp-block-columns .flip-front > div.uagb-section__inner-wrap > p:nth-child(2)"
    );

    paragraphs.forEach(paragraph => {
        $clamp(paragraph, {clamp: 'auto'});
    });
};

const handleSmoothScrollingAnchorLinks = () => {
    document.querySelectorAll('a[href^="#"].smooth').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
};

const setupMobileMenu = () => {
    const maxTabletWidth = 992;
    const button = document.getElementById("dropdown-button");
    const menu = document.getElementById("navigation-menu");
    const body = document.querySelector("body");

    const preventDefault = e => e.preventDefault();

    const hideMenu = () => {
        const dropdown = document.getElementById("navigation-menu");

        if (dropdown.classList.contains('visible')) {
            dropdown.classList.remove('visible');
        }

        if (body.classList.contains('locked')) {
            body.classList.remove('locked');
        }

        menu.removeEventListener('touchmove', preventDefault, false);
    };

    window.addEventListener('resize', event => {
        if (screen.width < maxTabletWidth) {
            hideMenu();
        }
    });

    button.onclick = () => {
        menu.classList.toggle("visible");
        if (menu.classList.contains("visible")) {
            if (menu.scrollHeight > menu.offsetHeight) {
                body.classList.add("locked");
            } else {
                menu.addEventListener('touchmove', preventDefault, false);
            }
        } else {
            hideMenu();
        }
    };

    window.onclick = (event) => {
        if (screen.width < maxTabletWidth) {
            if (event.path && !event.path.includes(document.getElementById("dropdown-button"))) {
                hideMenu();
            }
        }
    };
};

const setupContactForm = () => {
    window.Parsley
        .addValidator('phone', {
            validateString: function(value) {
                const phoneNumber = parsePhoneNumberFromString(value);
                return typeof phoneNumber !== 'undefined' && phoneNumber.isValid();
            },
            messages: {
                en: 'Invalid phone number',
                de: 'Invalid phone number',
            }
        });

    window.Parsley
        .addValidator('other', {
            validateString: function(value) {
                const country = jQuery("[name=contact-country]").val().toLowerCase();
                return (country !== "other" && country !== "andere") || !!value;
            },
            messages: {
                en: 'This value is required.',
                de: 'Dies ist ein Pflichtfeld.',
            }
        });

    jQuery('.parsley')
        .attr('data-parsley-trigger', 'blur')
        .attr('data-parsley-trigger-after-failure', 'blur')
        .attr('data-parsley-validate-if-empty', 'true');

    jQuery('.parsley-required')
        .attr('data-parsley-required', true);

    jQuery('.parsley-phone')
        .attr('data-parsley-phone', 'true');

    jQuery('.parsley-other')
        .attr('data-parsley-other', 'true');

    jQuery('.wpcf7-form').attr('data-parsley-validate', '').parsley();

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        jQuery(".swal2-close").click();

        Swal.fire({
            position: 'center',
            text: event.detail.apiResponse.message,
            showConfirmButton: false,
            showCloseButton: true,
            animation: false,
            customClass: {
                popup: 'animated zoomIn'
            },
        });
    }, false );
};

const openContactPopup = () => {
    if (window.location.hash === '#contact') {
        const targetElement = document.querySelector(`.popup-content.contact-form`);
        firePopup(targetElement);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    setupRellax();
    setupPopups();
    setupSlides();
    setupFlips();
    setupCarousel();
    setupContactForm();
    handleOverflowingParagraphs();
    handleSmoothScrollingAnchorLinks();
    setupMobileMenu();
    openContactPopup();
});
